import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Store Remove"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */

@Component({
    selector: 'app-icon-store-remove',
    templateUrl: './icon-store-remove.component.html',
    styleUrls: ['./icon-store-remove.component.scss'],
    standalone: false
})
export class IconStoreRemoveComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
